import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCircle, Facebook, Instagram, Youtube, Music2, CalendarClock } from 'lucide-react';
import { api, CONTACT, LOGO_URL } from '../lib/api';

const SOCIAL_ICONS = { facebook: Facebook, instagram: Instagram, tiktok: Music2, youtube: Youtube };

function MaintenancePage({ config }) {
  return (
    <div className="fixed inset-0 z-[100] bg-stone-900 text-white flex items-center justify-center overflow-hidden" data-testid="maintenance-page">
      {config.backgroundVideo ? (
        <video src={config.backgroundVideo} autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover opacity-30" />
      ) : config.backgroundImage ? (
        <img src={config.backgroundImage} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
      ) : null}
      <div className="relative z-10 max-w-2xl mx-auto px-6 text-center py-12">
        <img src={LOGO_URL} alt="Natur Autoescuela" className="h-16 md:h-20 mx-auto mb-8 bg-white/95 rounded-xl px-5 py-2" />
        <span className="inline-block text-[11px] font-bold uppercase tracking-widest bg-amber-400 text-stone-900 px-3 py-1 rounded-full mb-5" data-testid="maintenance-mode-badge">
          {config.mode === 'proximamente' ? 'Próximamente' : 'En mantenimiento'}
        </span>
        <h1 className="text-3xl md:text-5xl font-black mb-5" data-testid="maintenance-title">{config.title}</h1>
        <p className="text-stone-300 leading-relaxed whitespace-pre-line mb-4" data-testid="maintenance-subtitle">{config.subtitle}</p>
        {config.extraText && <p className="text-sm text-stone-400 leading-relaxed whitespace-pre-line mb-4">{config.extraText}</p>}
        {config.estimatedDate && (
          <p className="inline-flex items-center gap-2 text-sm text-amber-300 font-bold mb-6" data-testid="maintenance-date">
            <CalendarClock className="w-4 h-4" /> Volvemos: {new Date(config.estimatedDate).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        )}
        <div className="flex flex-col items-center gap-5 mt-2">
          {config.showWhatsapp && (
            <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="bg-green-500 hover:bg-green-600 transition-colors text-white font-bold text-sm px-6 py-3 rounded-full flex items-center gap-2" data-testid="maintenance-whatsapp">
              <MessageCircle className="w-4 h-4" /> Escríbenos por WhatsApp
            </a>
          )}
          <div className="flex gap-4">
            {Object.entries(config.socials || {}).filter(([, url]) => url).map(([key, url]) => {
              const Icon = SOCIAL_ICONS[key];
              return (
                <a key={key} href={url} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-stone-600 hover:border-amber-400 hover:text-amber-400 transition-colors flex items-center justify-center" data-testid={`maintenance-social-${key}`}>
                  {Icon && <Icon className="w-4 h-4" />}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function MaintenanceGate({ children }) {
  const [config, setConfig] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    api.getMaintenance().then(setConfig).catch(() => setConfig({ mode: 'operativa' }));
  }, []);

  if (config && config.mode !== 'operativa' && !pathname.startsWith('/admin')) {
    return <MaintenancePage config={config} />;
  }
  return children;
}
